import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackSearchQuery = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackSearchQueryEvent = useCallback(
    (searchQuery) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (searchQuery) {
          window.webengage.track("search", {
            query: searchQuery,
          });
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackSearchQueryEvent };
};

export default useTrackSearchQuery;
